import { useState } from 'react';

const Login = () => {

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const handleSubmit = async () => {
        const body = { email: email, password: password };
        const response = await fetch('https://ipj-api.vercel.app/api/login', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
        });
        const data = await response.json();

        if (!data.auth) {
            alert(data.message);
            return;
        }

        window.localStorage.setItem('token', data.token);
        window.location.href = '/prontuarios';
    }


    return ( 
        <div className="login-wrapper">
            <div className="login-container">
                <h2>Login</h2>
                <div>
                    <input
                        type="text"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <input
                        type="password"
                        placeholder="Senha"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <button  onClick={() => handleSubmit()}>Entrar</button>
                </div>
            </div>
        </div>
     );
}
 
export default Login;
